var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcXCircleContained({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0013 2.32878C4.42397 2.32878 2.33464 4.41811 2.33464 6.99544C2.33464 9.57277 4.42397 11.6621 7.0013 11.6621C9.57863 11.6621 11.668 9.57277 11.668 6.99544C11.668 4.41811 9.57863 2.32878 7.0013 2.32878ZM1.16797 6.99544C1.16797 3.77378 3.77964 1.16211 7.0013 1.16211C10.223 1.16211 12.8346 3.77378 12.8346 6.99544C12.8346 10.2171 10.223 12.8288 7.0013 12.8288C3.77964 12.8288 1.16797 10.2171 1.16797 6.99544ZM4.73267 4.72681C4.96047 4.499 5.32982 4.499 5.55763 4.72681L7.0013 6.17049L8.44498 4.72681C8.67278 4.499 9.04213 4.499 9.26994 4.72681C9.49774 4.95462 9.49774 5.32396 9.26994 5.55177L7.82626 6.99544L9.26994 8.43912C9.49774 8.66693 9.49774 9.03627 9.26994 9.26408C9.04213 9.49188 8.67278 9.49188 8.44498 9.26408L7.0013 7.8204L5.55763 9.26408C5.32982 9.49188 4.96047 9.49188 4.73267 9.26408C4.50486 9.03627 4.50486 8.66693 4.73267 8.43912L6.17634 6.99544L4.73267 5.55177C4.50486 5.32396 4.50486 4.95461 4.73267 4.72681Z",
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcXCircleContained);
export default __webpack_public_path__ + "static/media/ic-x-circle-contained.5bc7735dec94ee2635470491d7645f63.svg";
export { ForwardRef as ReactComponent };